class EmblaSlider extends HTMLElement {
  constructor() {
    super();
    this.autoplay = this.getAttribute('data-autoplay') === 'true';
    this.loop = this.getAttribute('data-loop') === 'true';
    this.autoplaySpeed =
      Number(this.getAttribute('data-autoplay-speed')) || 4000;
    this.staticDesktop = this.getAttribute('data-static-desktop') === 'true';
    this.fitMobile = this.hasAttribute('data-fit-mobile');
    this.mobileQuery = window.matchMedia('(max-width: 749px)');
    const options = {
      loop: this.loop,
      speed: 10,
      align: 'start',
    };
    if (this.staticDesktop) {
      options.breakpoints = {
        '(min-width: 750px)': { active: false },
      };
    }
    const plugins = [];
    if (this.autoplay) {
      plugins.push(EmblaCarouselAutoplay({ delay: this.autoplaySpeed }));
    }
    this.embla = EmblaCarousel(
      this.querySelector('.embla__viewport'),
      options,
      plugins,
    );

    this.slides = this.querySelectorAll('.embla__slide');

    this.prevBtns = this.querySelectorAll('.embla__arrow--prev');
    this.nextBtns = this.querySelectorAll('.embla__arrow--next');
    this.prevBtns.forEach((btn) =>
      btn.addEventListener('click', () => this.embla.scrollPrev()),
    );
    this.nextBtns.forEach((btn) =>
      btn.addEventListener('click', () => this.embla.scrollNext()),
    );

    this.dots = this.querySelectorAll('.embla__dot');
    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.embla.scrollTo(i));
    });

    this.embla.on('select', () => {
      this.selectDot();
      this.updateArrows();
    });
    if (this.fitMobile) {
      this.embla.on('reInit', () => {
        this.selectDot();
        this.updateArrows();
      });
    }
    this.selectDot();
    this.updateArrows();
  }

  updateArrows() {
    if (!this.loop) {
      this.prevBtns.forEach((btn) => {
        btn.disabled = !this.embla.canScrollPrev();
        btn.classList.toggle('is-disabled', !this.embla.canScrollPrev());
      });
      this.nextBtns.forEach((btn) => {
        btn.disabled = !this.embla.canScrollNext();
        btn.classList.toggle('is-disabled', !this.embla.canScrollNext());
      });
    }
  }

  // Slides fully in view, used to highlight the middle one when the row fits more than three.
  visibleCount() {
    const slide = this.slides[0];
    const viewport = this.embla.rootNode();
    if (!slide || !slide.offsetWidth) return 3;
    const gap = parseFloat(getComputedStyle(slide).marginRight) || 0;
    return Math.max(1, Math.round((viewport.clientWidth + gap) / (slide.offsetWidth + gap)));
  }

  highlightIndex(selectedIndex, slideCount) {
    if (!this.fitMobile || !this.mobileQuery.matches) {
      return (selectedIndex + 1) % slideCount;
    }
    const visible = Math.min(this.visibleCount(), slideCount);
    const first = Math.min(selectedIndex, slideCount - visible);
    return first + Math.floor((visible - 1) / 2);
  }

  selectDot() {
    const selectedIndex = this.embla.selectedScrollSnap();
    const slideCount = this.slides.length;
    if (!slideCount) return;

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-selected', i === selectedIndex);
    });

    // Only touch slides whose state changes: each attribute write invalidates the :has() rules above.
    const nextIndex = this.highlightIndex(selectedIndex, slideCount);
    this.slides.forEach((slide, i) => {
      const selected = i === selectedIndex;
      const next = i === nextIndex;
      if (slide.hasAttribute('data-selected') !== selected) {
        if (selected) slide.setAttribute('data-selected', 'true');
        else slide.removeAttribute('data-selected');
      }
      if (slide.hasAttribute('data-next') !== next) {
        if (next) slide.setAttribute('data-next', 'true');
        else slide.removeAttribute('data-next');
      }
    });
  }
}

if (!customElements.get('embla-slider')) {
  customElements.define('embla-slider', EmblaSlider);
}
